(function() {

    document.querySelectorAll('.dropdown-texts-block').forEach(block => {
        document.querySelectorAll('.dropdown-texts-block-list-item').forEach(item => {

            const title = item.querySelector('.dropdown-texts-block-list-item-title');
            const content = item.querySelector('.dropdown-texts-block-list-item-content');

            title.addEventListener('click', () => {
                if ( item.classList.contains('open') ) {                    
                    content.classList.remove("show");
                    item.classList.remove('open');
                } else {
                    item.classList.add('open');
                    requestAnimationFrame(() => {
                        content.classList.add("show");
                    });
                }
            });
        });
    });

})();